import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./Components.css";
import reportWebVitals from "./reportWebVitals";

import { createBrowserRouter, RouterProvider } from "react-router-dom";
import environment from "./Environment";
import "react-toastify/dist/ReactToastify.min.css";
// import loadable from "@loadable/component";

import App from "./App";
import LoginPage from "./LoginPage";
import SignupPage from "./SignupPage";
import HomeViewWrapper from "./HomeViewWrapper";
import SettingsPageContainerWrapper from "./SettingsPageContainerWrapper";
// import PaywallPage from "./PaywallPage";
import PaywallPageContainer from "./PaywallPageContainer";
import PaymentSuccess from "./PaymentSuccess";
import PaymentCancel from "./PaymentCancel";
// import NoteView from "./components/NoteView";
// import AnalysePageContainerTopWrapper from "./AnalysePageContainerTopWrapper";
// import Terms from "./Terms";
import ForgotPasswordPage from "./ForgotPasswordPage";
import PasswordResetPage from "./PasswordResetPage";
import AddSourcePageContainer from "./AddSourcePageContainer";
// import Help from "./Help";
// import Privacy from "./Privacy";
import IncompletePaymentPageContainer from "./IncompletePaymentPageContainer";
// import AddressPage from "./AddressPage";

// const Router = createFarceRouter({
//     historyProtocol: new BrowserProtocol(),
//     historyMiddlewares: [queryMiddleware],
//     routeConfig: makeRouteConfig(
//         <Route path="/">
//             <Route Component={App} />

//             <Route path="/login">
//                 <Route Component={LoginPage} />
//             </Route>

//             <Route path="/forgot-password">
//                 <Route Component={ForgotPasswordPage} />
//             </Route>
//             <Route path="/reset/:uid/:token" Component={PasswordResetPage} />

//             <Route path="/terms">
//                 <Route Component={Terms} />
//             </Route>

//             <Route path="/privacy">
//                 <Route Component={Privacy} />
//             </Route>

//             <Route path="/help">
//                 <Route Component={Help} />
//             </Route>

//             <Route path="/topic-analysis">
//                 <Route Component={Help} />
//             </Route>

//             <Route path="/success">
//                 <Route Component={PaymentSuccess} />
//             </Route>

//             <Route path="/cancel">
//                 <Route Component={PaymentCancel} />
//             </Route>

//             <Route path="/signup">
//                 <Route Component={SignupPage} />
//             </Route>

//             <Route path="home">
//                 <Route Component={HomeViewWrapper} />
//                 <Route path="add-source" Component={AddSourcePageContainer} />
//                 <Route path="complete-payment" Component={IncompletePaymentPageContainer} />
//                 <Route
//                     path="settings"
//                     Component={SettingsPageContainerWrapper}
//                 />
//                 <Route path="upgrade" Component={PaywallPageContainer} />
//                 <Route
//                     path="analyse"
//                     Component={AnalysePageContainerTopWrapper}
//                 />
//                 <Route path="trending" Component={HomeViewWrapper} />
//                 <Route path="note-view" Component={NoteView} />
//                 <Route path="billing" Component={AddressPage} />
//             </Route>
//         </Route>
//     ),

//     render: createRender({}),
// });

const router = createBrowserRouter([
    {
        path: "/",
        element: <App />,
    },
    {
        path: "login",
        element: <LoginPage />,
    },
    {
        path: "signup",
        element: <SignupPage/>,
    },
    {
        path: "home",
        element: <HomeViewWrapper />,
    },
    {
        path: "settings",
        element: <SettingsPageContainerWrapper />,
    },
    {
        path: "add-source",
        element: <AddSourcePageContainer />,
    },
    {
        path: "upgrade",
        element: <PaywallPageContainer/>,
    },
    {
        path: "success",
        element: <PaymentSuccess />,
    },
    {
        path: "cancel",
        element: <PaymentCancel />,
    },
    {
        path: "complete-payment",
        element: <IncompletePaymentPageContainer />,
    },
    {
        path: "/reset/:uid/:token",
        element: <PasswordResetPage />,
    },
    {
        path: "forgot-password",
        element: <ForgotPasswordPage />,
    },
    {
        path: "trending",
        element: <HomeViewWrapper />,
    },
]);

// ReactDOM.createRoot(document.getElementById("root")).render(
//     <React.StrictMode>
//         <RouterProvider router={router} />
//     </React.StrictMode>
// );

ReactDOM.render(
    <RouterProvider router={router} />,
    document.getElementById("root")
);

// ReactDOM.render(
//     <Router resolver={new Resolver(environment)} />,
//     document.getElementById("root")
// );
